module.exports = __webpack_public_path__ + "static/img/17.fb6fd6b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/17.png
// module id = BhW8
// module chunks = 0